import i18n, { Resource } from 'i18next';
import { initReactI18next } from 'react-i18next';
import { translation as enTranslation } from './en/index';
import { translation as nlTranslation } from './nl/index';
import { translation as frTranslation } from './fr/index';
import { translation as hrTranslation } from './hr/index';
import LanguageDetector from './language-detector';

const resources: Resource = {
  nl: {
    translation: nlTranslation,
  },
  fr: {
    translation: frTranslation,
  },
  en: {
    translation: enTranslation,
  },
  hr: {
    translation: hrTranslation,
  },
};

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources,
    fallbackLng: 'nl',
    interpolation: {
      escapeValue: false,
    },
  });
